import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import FormDialog, {FormDialogProps} from 'cl-dialogs/FormDialog';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';

interface DeleteAttributeDialogProps extends FormDialogProps {
  count?: number;
}

const DeleteAttributesDialog: React.FunctionComponent<DeleteAttributeDialogProps> = ({count, ...props}) => {
  return (
    <FormDialog
      formName={GENERAL_ACTIONS_TYPES.DELETE_PRODUCTS}
      title={count === 1 ? 'Delete Attribute' : 'Delete Attributes'}
      text={
        <div>
          Are you sure you want to delete {count === 1 ? 'this attribute' : 'these attributes'}? <br /> Once you delete
          an attribute, it will be immediately removed along with the values from all products
        </div>
      }
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.DELETE_ATTRIBUTE]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          lastActionColor="error"
        />
      }
      {...props}
    />
  );
};

export default DeleteAttributesDialog;
